// import ChatBrochure from './components/ChatBrochure'
import './brochure.css'

import { useEffect, useState } from 'react'
import { useWindowSize } from 'react-use'

import noraScritta from '../../Components/Common/images/nora.png'
import FooterBrochure from './components/FooterBrochure'
import ParagrafiBrochure from './components/ParagrafiBrochure'
import noraAvatar from './NoraAvatar.png'

const WIDTH_DIMENSION = 1000

export const Brochure = () => {
  const { width = 0 } = useWindowSize()
  const isMobile = width <= WIDTH_DIMENSION
  const [isDarkMode, setIsDarkMode] = useState(false)

  // Load Poppins font from Google Fonts
  useEffect(() => {
    const link = document.createElement('link')
    link.href =
      'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap'
    link.rel = 'stylesheet'
    document.head.appendChild(link)

    return () => {
      // Cleanup: remove the link when component unmounts
      const existingLink = document.querySelector('link[href*="fonts.googleapis.com"]')
      if (existingLink) {
        document.head.removeChild(existingLink)
      }
    }
  }, [])

  // Carica il tema salvato dal localStorage
  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const savedTheme = window.localStorage.getItem('brochure-theme')
      if (savedTheme) {
        setIsDarkMode(savedTheme === 'dark')
      }
    }
  }, [])

  // Salva il tema nel localStorage quando cambia
  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem('brochure-theme', isDarkMode ? 'dark' : 'light')
    }
    // Aggiungi/rimuovi classe al body per il tema
    if (typeof document !== 'undefined') {
      if (isDarkMode) {
        document.body.classList.add('dark-mode')
      } else {
        document.body.classList.remove('dark-mode')
      }
    }
  }, [isDarkMode])

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode)
  }

  return (
    <div className={`brochure-container ${isDarkMode ? 'dark-mode' : ''}`}>
      {/* Dark Mode Toggle */}
      <div className="brochure-theme-toggle">
        <button
          onClick={toggleDarkMode}
          className={`theme-switch ${isDarkMode ? 'dark' : 'light'}`}
          aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
        >
          <div className="theme-switch-track">
            <div className="theme-switch-thumb">{isDarkMode ? '🌙' : '☀️'}</div>
          </div>
        </button>
      </div>

      {/* Hero Section - Minimal Design */}
      <div className={isMobile ? 'brochure-hero-mobile' : 'brochure-hero'}>
        <div className="brochure-hero-content">
          {/* Logo e Brand */}
          <div className="brochure-brand-section">
            <img src={noraAvatar} alt="Nora Avatar" className="brochure-avatar" />
            <img src={noraScritta} alt="Nora AI Travel Assistant" className="brochure-logo-text" />
          </div>

          {/* Titolo e sottotitolo centrati */}
          <div className="brochure-text-section">
            <h1 className={isMobile ? 'brochure-title-mobile' : 'brochure-title'}>
              NORA AI Travel Assistant
            </h1>
            <p className={isMobile ? 'brochure-subtitle-mobile' : 'brochure-subtitle'}>
              L'intelligenza artificiale che rivoluziona i viaggi d'affari
            </p>
          </div>
        </div>
      </div>

      {/* Contenuto principale - Layout a colonna singola */}
      <div className={isMobile ? 'brochure-content-mobile' : 'brochure-content'}>
        <div className="brochure-content-wrapper">
          <ParagrafiBrochure />
        </div>
      </div>

      {/* Chat fissa - Commentata per ora */}
      {/* <div
        style={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          width: isMobile ? 'calc(100% - 40px)' : 400,
          height: 500,
          zIndex: 1000
        }}
      >
        <ChatBrochure />
      </div> */}

      {/* Footer */}
      <div style={{ position: 'relative', zIndex: 2 }}>
        <FooterBrochure isDarkMode={isDarkMode} />
      </div>
    </div>
  )
}
